import React, { useState, useRef, useCallback } from "react";

import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";

const PaymentLinkingColumn = ({
  row,
  handleOpenLinkModal,
  handleOpenUnlinkModal,
  handleOpenLinkLedgerModal,
  handleOpenUnlinkLedgerModal,
  handleOpenLinkTripModal,
  handleOpenAssignChargeModal,
  handleOpenPassthroughModal,
  handleOpenReferralFeeModal,
  showFundsLedger,
  showPassthrough = false,
  showContractAndOFR = true,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggleCreateLinkMenu = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleLinkPayment = useCallback((event) => {
    handleClose(event);

    const triggerName = event.currentTarget.dataset.name;

    switch (triggerName) {
      case "contract":
      case "ofr":
        handleOpenLinkModal(triggerName);
        break;
      case "relink":
        handleOpenLinkModal(!!row?.clientPaymentHistoryId ? "contract" : "ofr");
        break;
      case "unlink":
        handleOpenUnlinkModal();
        break;
      case "ledger":
        handleOpenLinkLedgerModal();
        break;
      case "trip":
        handleOpenLinkTripModal();
        break;
      case "incidentals":
        handleOpenAssignChargeModal();
        break;
      case "passthrough":
        handleOpenPassthroughModal();
        break;
      case "referralFee":
        handleOpenReferralFeeModal();
        break;
      default:
        break;
    }
  }, [handleOpenLinkModal, handleOpenUnlinkModal, handleOpenLinkLedgerModal, handleOpenLinkTripModal, handleOpenAssignChargeModal, handleOpenPassthroughModal, handleOpenReferralFeeModal, row]);

  if (row.fundsLedgerId) {
    return (
      <div>
        <button
          onClick={handleOpenUnlinkLedgerModal}
          className="d-block base-button icon-button icon-button-small btn-danger ml-2"
        >
          <span className="material-icons">link_off</span>
        </button>
      </div>
    );
  }

  return !row.tripId ?
    <div>
      <button
        ref={anchorRef}
        id="create-link-button"
        aria-controls={open ? "create-link-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleToggleCreateLinkMenu}
        className="d-block base-button icon-button icon-button-small evo-dark-green ml-2"
      >
        <span className="material-icons">add_link</span>
      </button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        transition
        sx={{ zIndex: 1 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="create-link-menu"
                  aria-labelledby="create-link-button"
                  sx={{ p: 0 }}
                >
                  {showContractAndOFR && (
                    <MenuItem
                      data-name="contract"
                      onClick={handleLinkPayment}
                    >
                      Contract
                    </MenuItem>
                  )}
                  {showContractAndOFR && (
                    <MenuItem
                      data-name="ofr"
                      onClick={handleLinkPayment}
                    >
                      OFR
                    </MenuItem>
                  )}
                  {(row.categoryCode === "601" || (!!row.objectType && ["503", "504"].includes(row.categoryCode))) && row.objectType !== "intent" && (
                    <MenuItem
                      data-name="trip"
                      onClick={handleLinkPayment}
                    >
                      Incidentals
                    </MenuItem>
                  )}
                  {!row.objectType && ["503", "504"].includes(row.categoryCode) && (
                    <MenuItem
                      data-name="incidentals"
                      onClick={handleLinkPayment}
                    >
                      Incidentals
                    </MenuItem>
                  )}
                  {showFundsLedger && (
                    <MenuItem
                      data-name="ledger"
                      onClick={handleLinkPayment}
                    >
                      Funds Ledger
                    </MenuItem>
                  )}
                  {showPassthrough && (
                    <MenuItem
                      data-name="passthrough"
                      onClick={handleLinkPayment}
                    >
                      Passthrough
                      <span className="menu-new-badge">NEW</span>
                    </MenuItem>
                  )}
                  {showPassthrough && (
                    <MenuItem
                      data-name="referralFee"
                      onClick={handleLinkPayment}
                    >
                      Referral Fee
                      <span className="menu-new-badge">NEW</span>
                    </MenuItem>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
    : (
      <div className="display-flex">
        <button
          data-name="unlink"
          onClick={handleLinkPayment}
          className="d-block base-button icon-button icon-button-small btn-danger ml-2"
        >
          <span className="material-icons">link_off</span>
        </button>
      </div>
    );
};

export default PaymentLinkingColumn;
